import { FeatureFlagEnum } from '@shared/enums/feature-flag.enum';
import { EnvironmentModel } from '@shared/models/environment.model';

export const environment: EnvironmentModel = {
  production: false,
  urls: { apiUrl: 'https://api.dashly-dev.com' },
  sentryDSN: 'https://76881b87ff014000bde9e53bd7994c0a@sentry.io/1470751',
  googleCloudPlatformApiKey: 'AIzaSyBGqH3THZJ5ihSEpuXeBcEHxwe3GeyVk1k',
  maintenanceUrl: 'https://storage.googleapis.com/dashlydev-ui-apps-config/config.json',
  featureConfig: {
    [FeatureFlagEnum.AddSmartSearchForm]: true,
    [FeatureFlagEnum.MobileAppRedirect]: false,
  },
  companyAndNetworkIds: {
    dashlyCompanyId: '1',
    mabNetworkId: '1',
  },
  firebaseConfig: {
    apiKey: 'AIzaSyA-yUw2_Ipe7oeYJ1Pp3dJi4ArEcYOe8xc',
    authDomain: 'dashlydev.firebaseapp.com',
    databaseURL: 'https://dashlydev.firebaseio.com',
    projectId: 'dashlydev',
    storageBucket: 'dashlydev.firebasestorage.app',
    messagingSenderId: '515479880764',
    appId: '1:515479880764:web:471f048cb146d712952f39',
    measurementId: 'G-6BQDXGR6PP',
  },
};
